export enum HILMode {
  None = 'None',
  Bot = 'bot',
  Corp = 'corp',
  Hierarchy = 'hierarchy',
}
